export default "__VITE_ASSET__ChCL3JCX__"